import gsap from "gsap";
import VideoModule from "./videoModule";
import Header from "./header";
import { GSDevTools } from "gsap/GSDevTools";
import Animations from "./animations";

const videoPosterOverlay = (() => {

    const SELECTOR_MODULE = '.module-container__video-poster-overlay';
    let videoModules = [];

    const initialize = () => {

        const elements = getModuleElements();

        gsap.registerPlugin(GSDevTools);


        if (elements.length) {

            elements.forEach((el, idx) => {
                videoModules.push(initVideo(el));

                if (el.dataset.animate !== undefined) {
                    initAnimations(el, videoModules[idx]);
                }

            })

        }
    }

    const getModuleElements = () => document.querySelectorAll(SELECTOR_MODULE);

    const initVideo = (module) => {

        const videoModuleEl = module.querySelector(VideoModule.SELECTOR_MODULE);

        if (!videoModuleEl) return;

        const videoModule = VideoModule.initialize(videoModuleEl);

        return videoModule;

    };

    // TODO: add image to be faded out. identical what poster has. poster will be just a kind of fallback.
    const initAnimations = (module, videoModule) => {
        const animated = module.querySelectorAll('.eyebrow, .text');

        const revealAnimated = () => {

            Animations.revealElements(animated, {
                duration: 1,
                stagger: .5,
                ease: 'ease.in'
            });
        };

       


        // handler function revealing text elements when video ends
        const handleVideoEnded = () => {
            revealAnimated();
            videoModule.revealPoster();
        };

        // handle case when user hits the play btn
        const handleVideoPlay = () => {

            let isVisible = false;

            animated.forEach(el => {
                if (el.style.visibility) {
                    isVisible = true;
                }
            })

            // hide if visible
            if (isVisible) {

                gsap.timeline()
                    .to(animated,
                        {
                            autoAlpha: 0,
                            y: 30,
                            duration: 1,
                            stagger: .5,
                            ease: 'ease.out',
                        })
                    .to(videoModule.controls, { autoAlpha: 1, duration: 0.5 }, "<")
                    .to(videoModule.poster, { autoAlpha: 0, duration: 0.5 }, "<");
            }

        };

        videoModule.video?.addEventListener("ended", handleVideoEnded);
        videoModule.video?.addEventListener("play", handleVideoPlay);

        // TODO FF poster bug fix, but need to readd again when ended!
        /* videoModule.video?.addEventListener("playing", () => {
            videoModule.video.removeAttribute("poster");
        }, { once: true}); */

        let played = false; // state to track if already played

        const timeline = gsap.timeline({
            paused: true,
            scrollTrigger: {
                trigger: module,
                start: () => `top-=${Header.getCurrentHeight()} top`,
                end: () => "+=" + window.innerHeight * 2,
                pin: true,
                markers: false,
                invalidateOnRefresh: true,
                onEnter: self => {

                    // ensure playing animation only once
                    if (played) return;
                    played = true;

                    // load video
                    videoModule.load()
                        .then(() => {
                            self.animation.resume();
                        })
                        .catch((err) => {
                            console.err(err)
                        });

                    /* self.animation.pause(); */
                },
                onEnterBack: () => revealAnimated(),
                onLeave: () => {
                    videoModule.reset();
                },
                onLeaveBack: () => {
                    videoModule.reset();
                    revealAnimated();

                }
            },

        });
        timeline.from(animated,
            {
                autoAlpha: 0,
                y: 30,
                duration: 1,
                stagger: .5,
                ease: 'ease.in'
            })
            .addPause()
            /* .to({}, { duration: 1 }) */
            .to(animated,
                {
                    autoAlpha: 0,
                    y: 30,
                    duration: 1,
                    stagger: .5,
                    ease: 'ease.out',
                })
            .to(videoModule.poster, {
                autoAlpha: 0,
                duration: 1,
            }, "<")
            .to(videoModule.video, {
                autoAlpha: 1,
                duration: 1,
                onStart: () => {
                    videoModule.play();
                }

            }, "<")
            .to({}, { duration: 2 });


            // for debugging animations only
        /* GSDevTools.create({animation: timeline}); */

    }

    return {
        initialize
    }

})();


export default videoPosterOverlay;